import React, { useEffect, useState } from 'react';
import { Layout, Menu, Avatar, Image, Select, Button } from 'antd';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import {
    DashboardOutlined,
    SettingOutlined,
    DiscordOutlined,
    LogoutOutlined,
    RobotOutlined, UserOutlined, YoutubeOutlined, YoutubeFilled
} from '@ant-design/icons';
import { supabase } from './supabaseClient';
import { useTranslation } from 'react-i18next';
import { loadStripe } from '@stripe/stripe-js';



const { Sider } = Layout;

const Navigation = ({ user }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { t, i18n } = useTranslation();
    const [quotas, setQuotas] = useState(null);
    const [userName, setUserName] = useState('');
    const [currentLanguage, setCurrentLanguage] = useState(i18n.language || 'en');

    console.log(i18n.language);
    const handleLogout = async () => {
        try {
            const { error } = await supabase.auth.signOut();
            if (error) throw error;
            navigate('/login');
        } catch (error) {
            console.error('Error logging out:', error.message);
        }
    };

    useEffect(() => {
        if (user) {
            // Google 인증을 통해 로그인한 경우 사용자 이름 가져오기
            const userMetadata = user.user_metadata;
            if (userMetadata && userMetadata.full_name) {
                setUserName(userMetadata.full_name);
            } else {
                setUserName(user.email); // 폴백으로 이메일 사용
            }
        }
    }, [user]);

    useEffect(() => {
        if (user) {
            fetchUserQuotas();
        }
    }, [user]);

    const fetchUserQuotas = async () => {
        try {
            const { data, error } = await supabase
                .from('user_quotas')
                .select('summarization_meeting_quota, translation_meeting_quota')
                .eq('user_id', user.id)
                .single();

            if (error) throw error;
            setQuotas(data);
        } catch (error) {
            console.error('쿼터 정보를 가져오는 중 오류 발생:', error.message);
        }
    };

    const handleUpgrade = () => {
        navigate('/subscription');
    };

    // Update language change handler
    const handleLanguageChange = (value) => {
        i18n.changeLanguage(value);
        setCurrentLanguage(value);
    };

    // Add useEffect to sync language
    useEffect(() => {
        setCurrentLanguage(i18n.language || 'en');
    }, [i18n.language]);

    return (
        <Sider
            width={250}
            theme="light"
            style={{
                borderRight: '1px solid #f0f0f0',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                display: 'flex',
                flexDirection: 'column',
                height: '100vh',
                position: 'fixed',
                left: 0,
                top: 0,
                bottom: 0,
                overflowY: 'auto'
            }}
        >
            <div style={{
                padding: '28px 20px',
                textAlign: 'center',
                borderBottom: '1px solid rgba(26,115,232,0.1)',
                background: 'linear-gradient(to bottom, rgba(44, 123, 229, 0.03), transparent)'
            }}>
                <Link to="/">
                    <Image
                        src="/assets/icon128.png"
                        alt="ELI Logo"
                        preview={false}
                        style={{
                            width: '80px',
                            height: '80px',
                            borderRadius: '50%',
                            objectFit: 'cover',
                            marginBottom: '20px',
                            boxShadow: '0 4px 12px rgba(26,115,232,0.12)',
                            transition: 'transform 0.2s ease',
                            cursor: 'pointer',
                        }}
                        onMouseOver={e => e.currentTarget.style.transform = 'translateY(-2px)'}
                        onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
                    />
                </Link>
                <div style={{
                    fontSize: '20px',
                    fontWeight: '700',
                    marginBottom: '4px'
                }}>
                    <span style={{ color: '#1a73e8' }}>Supercharge</span>
                </div>
                <div style={{
                    fontSize: '15px',
                    color: '#666666',
                    fontWeight: '500',
                    marginBottom: '8px'
                }}>
                    In-Meeting Performance
                </div>
            </div>

            <div style={{ padding: '24px 16px', borderBottom: '1px solid #f0f0f0' }}>
                <div style={{ marginBottom: '16px' }}>
                    <Select
                        value={currentLanguage}
                        onChange={handleLanguageChange}
                        style={{ width: '100%' }}
                    >
                        <Select.Option value="en">English</Select.Option>
                        <Select.Option value="ko">한국어</Select.Option>
                        <Select.Option value="ja">日本語</Select.Option>
                        <Select.Option value="zh-CN">简体中文</Select.Option>
                        <Select.Option value="fr">Français</Select.Option>
                        <Select.Option value="es">Español</Select.Option>
                        <Select.Option value="de">Deutsch</Select.Option>
                        <Select.Option value="ru">Русский</Select.Option>
                    </Select>
                </div>

                {user ? (
                    <>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: 16,
                            padding: '10px',
                            backgroundColor: '#f5f5f5',
                            borderRadius: '8px'
                        }}>
                            <Avatar size="large" icon={<UserOutlined />} />
                            <span style={{ marginLeft: '10px', wordBreak: 'break-all', fontWeight: 'bold' }}>
                                {userName}
                            </span>
                        </div>
                        <Menu
                            mode="inline"
                            selectedKeys={[location.pathname]}
                            style={{ borderRight: 0 }}
                        >
                            <Menu.Item key="/" icon={<DashboardOutlined />}>
                                <Link to="/">{t("My Meetings")}</Link>
                            </Menu.Item>
                            {/* <Menu.Item key="/agent/list" icon={<RobotOutlined />}>
                                <Link to="/agent/list">{t("My Meet Assistants")}</Link>
                            </Menu.Item>
                            <Menu.Item key="/how-to-use" icon={<YoutubeOutlined />} data-tour="how-to-use"                            >
                                <Link to="/how-to-use">{t("How to Use")}</Link>
                            </Menu.Item> */}
                            <Menu.Item key="/settings" icon={<SettingOutlined />}>
                                <Link to="/settings">{t("Settings")}</Link>
                            </Menu.Item>
                        </Menu>
                    </>
                ) : (
                    <div
                        onClick={() => navigate('/login')}
                        style={{
                            cursor: 'pointer',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            padding: '10px',
                            backgroundColor: '#f5f5f5',
                            borderRadius: '8px'
                        }}
                    >
                        <UserOutlined style={{ marginRight: '5px' }} /> {t('Login')}
                    </div>
                )}
            </div>

            {user && quotas && (
                <div style={{ padding: '16px', borderTop: '1px solid #f0f0f0' }}>
                    <div style={{
                        backgroundColor: '#f5f5f5',
                        borderRadius: '8px',
                        padding: '16px',
                        marginBottom: '12px'
                    }}>
                        <h4 style={{ margin: '0 0 8px 0' }}>{t("Quota")}</h4>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '8px'
                        }}>
                            <span>{t("Transcript")}</span>
                            <span style={{ fontWeight: 'bold' }}>Unlimited</span>
                        </div>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '8px'
                        }}>
                            <span>{t("Live Summary")}</span>
                            <span style={{ fontWeight: 'bold' }}>{quotas.summarization_meeting_quota} left</span>
                        </div>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '12px'
                        }}>
                            <span>{t("Live Translation")}</span>
                            <span style={{ fontWeight: 'bold' }}>{quotas.translation_meeting_quota} left</span>
                        </div>

                        <Button onClick={handleUpgrade} type="primary" block>
                            {t("Change Plan")}
                        </Button>
                    </div>
                </div>
            )}


            {user && (
                <div style={{ padding: '16px', borderTop: '1px solid #f0f0f0' }}>
                    <Menu mode="inline" selectable={false}>
                        <Menu.Item
                            key="logout"
                            icon={<LogoutOutlined />}
                            onClick={handleLogout}
                        >
                            {t("Logout")}
                        </Menu.Item>
                    </Menu>
                </div>
            )}


            <div style={{
                padding: '16px',
                borderTop: '1px solid #f0f0f0',
                display: 'flex',
                justifyContent: 'space-around',
                alignItems: 'center'
            }}>
                <DiscordOutlined
                    style={{ fontSize: '24px', cursor: 'pointer' }}
                    onClick={() => window.open('https://discord.gg/gXxQgeP6FV')}
                    data-tour="discord"
                />
                <YoutubeOutlined
                    style={{ fontSize: '24px', cursor: 'pointer' }}
                    onClick={() => window.open('https://www.youtube.com/@EliMeetPanel')}
                />
            </div>

        </Sider>
    );
};

export default Navigation;